import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ISubcode } from '../../../../models/codes.model'
import { doCreateSubcode } from '../../../../store/code.slice';
import { doGetCommonCodes } from '../../../../store/commonCode.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../../components/Loader';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/system/code/Editor';
import { errorVariant, infoVariant, successVariant, warningVariant } from '../../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemCodeSubcodeCreate: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.code);
  const { isLoading: commonCodeLoading } = useSelector((state: RootState) => state.commonCode);
  const { enqueueSnackbar } = useSnackbar();

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);
  
  const onSubmit = async (req: ISubcode) => {
    const res = await dispatch(doCreateSubcode(id, req));
    
    switch (res?.status) {
      case 200:
        dispatch(doGetCommonCodes());
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push(`/system/code/${id}/subcode${location.search}`);
        break;
      case 400:
        enqueueSnackbar(t('system.code.message1'), infoVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading || commonCodeLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.code.title4')}
      />
      <Editor
        code={null}
        onSubmit={onSubmit}
        cancelPath={`/system/code/${id}/subcode${location.search}`}
      />
      <Footer />
    </div>
  )
}

export default SystemCodeSubcodeCreate;
